module.exports = __webpack_public_path__ + "img/1559705667.9a8819e3.jpg";